angular.module('picmonic-common')
    .directive('profilePicture', function(){
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="profile-picture" ng-style="{\'background-image\' : \'url(\' + avatarUrl() + \')\'}"></div>',
            scope: {
                user: '='
            },
            controller: ['$rootScope', '$scope', function($rootScope, $scope){
                $scope.avatarUrl = function(){
                    if (!$scope.user) {
                        return '/uploads/avatar_users/default.png';
                    } else if ($scope.user.avatar) {
                        return $scope.user.avatar;
                    } else if($scope.user.uploaded_avatar) {
                        if ($scope.user.uploaded_avatar.indexOf('//') === 0 || $scope.user.uploaded_avatar.indexOf('/uploads') === 0) {
                            return $scope.user.uploaded_avatar;
                        } else {
                            return  $rootScope.upload_url+'/avatar_users/'+$scope.user.uploaded_avatar;
                        }
                    } else {
                        return '/uploads/avatar_users/default.png';
                    }
                };
            }]
        };
    });

